import {
  Container,
  Row,
  Col,
  Button,
  ButtonGroup,
} from "react-bootstrap";
import {
  useGetScheduleDaysQuery,
  useGetScheduleProgramsQuery,
} from "../slices/playlistsApiSlice";
import { viewTime } from "../util/dateTimeFunctions.jsx";
import { Fragment, useEffect, useState } from "react";

const Hero = () => {
  const [selectedDateId, setSelectedDateId] = useState(null);
  const [skipSchedulePrograms, setSkipSchedulePrograms] = useState(true);

  // const { userInfo } = useSelector((state) => state.auth);
  const programTime = viewTime;
  const {
    data: scheduleDays,
    isLoading: scheduleDaysLoading,
    isError: scheduleDaysError,
  } = useGetScheduleDaysQuery();

  const {
    data: schedulePrograms,
    isLoading: scheduleProgramsLoading,
    isError: scheduleProgramsError,
  } = useGetScheduleProgramsQuery(selectedDateId, {
    skip: skipSchedulePrograms,
  });

  useEffect(() => {
    if (selectedDateId !== null) {
      setSkipSchedulePrograms(false);
    }
  }, [selectedDateId]);

  useEffect(() => {
    if (scheduleDays) {
      if (selectedDateId === null) {
        setSelectedDateId(scheduleDays[5]._id);
      }
    }
    // eslint-disable-next-line
  }, [scheduleDays]);

  const handleDateChange = (e) => {
    e.preventDefault();
    setSelectedDateId(e.target.id);
  };

  return (
    <Container fluid>
      {scheduleDaysLoading && "Loading Schedule..."}
      {scheduleDaysError && "Error loading Schedule"}
      {scheduleDays && (
        <Fragment>
          <Row>
            <Col>
              <ButtonGroup
                size="sm"
                className="mb-2 d-flex shadow-lg"
              >
                {scheduleDays.map((dateOfSchedule, dateOfScheduleIndex) => (
                  <Button
                    variant={
                      dateOfSchedule._id === selectedDateId
                        ? "primary"
                        : "light"
                    }
                    key={dateOfSchedule._id}
                    id={dateOfSchedule._id}
                    onClick={handleDateChange}
                    className={
                      dateOfScheduleIndex === 5
                        ? "border-primary border-5 "
                        : ""
                    }
                  >
                    {dateOfScheduleIndex === 5 ? "Today" : dateOfSchedule.txDow}
                    <br />
                    {dateOfSchedule.dateOfMonth}
                  </Button>
                ))}
              </ButtonGroup>
            </Col>
          </Row>
          {scheduleProgramsLoading && "Loading Programs..."}
          {scheduleProgramsError && "Error loading Programs"}
          {schedulePrograms &&
            schedulePrograms.map((scheduleProgram, scheduleProgramId) => (
              <Row key={scheduleProgramId}>
                <Col
                  xs={3}
                  className="fs-6 text-end me-4 mt-2 pt-2"
                >
                  {programTime(scheduleProgram.startTime.startTime)}
                </Col>
                <Col
                  xs={6}
                  className="border-top border-success border-2 mt-2 pt-2"
                >
                  <Row className="fs-6 text-success">{scheduleProgram.name.name}</Row>
                  <Row className="ms-5 text-dark-emphasis">
                    <small>{scheduleProgram.synopsis.synopsis}</small>
                  </Row>
                </Col>
              </Row>
            ))}
        </Fragment>
      )}
    </Container>
  );
};

export default Hero;
